/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendVentureFundLoanDto } from '../../models/backend-venture-fund-loan-dto';
import { BackendVentureFundLoanRequestDto } from '../../models/backend-venture-fund-loan-request-dto';

export interface VentureFundsVentureFundLoansCreate$XWwwFormUrlencoded$Params {
  body: BackendVentureFundLoanRequestDto;
}

export function ventureFundsVentureFundLoansCreate$XWwwFormUrlencoded(
  http: HttpClient,
  rootUrl: string,
  params: VentureFundsVentureFundLoansCreate$XWwwFormUrlencoded$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendVentureFundLoanDto>> {
  const rb = new RequestBuilder(rootUrl, ventureFundsVentureFundLoansCreate$XWwwFormUrlencoded.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/x-www-form-urlencoded');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendVentureFundLoanDto>;
    }),
  );
}

ventureFundsVentureFundLoansCreate$XWwwFormUrlencoded.PATH = '/api/venture_funds/venture-fund-loans/';
